const PIX_METHOD = "PIX";
const COUPON_TYPE_PERCENTAGE = "percent";

export function calcValue(wasPreviousStudent, offer, coupon, billingType) {
  const basePrice = offer?.price || 0;
  let currentPrice = basePrice;

  if (offer?.hasStudentDiscount && wasPreviousStudent) {
    const studentDiscountValue = basePrice - (offer?.resellPrice || 0);
    currentPrice -= studentDiscountValue;
  }

  if (coupon) {
    if (coupon.nonCumulative) {
      const studentDiscountValue =
        offer?.hasStudentDiscount && wasPreviousStudent
          ? basePrice - (offer?.resellPrice || 0)
          : 0;
      const couponDiscountValue = calculateCouponDiscountValue(
        coupon,
        basePrice
      );

      if (couponDiscountValue >= studentDiscountValue) {
        currentPrice = basePrice - couponDiscountValue;
      }
    } else {
      const discount = calculateCouponDiscountValue(coupon, currentPrice);
      currentPrice -= discount;
    }
  }

  if (billingType === PIX_METHOD && offer?.pixDiscount > 0) {
    const pixDiscountValue = currentPrice * (offer.pixDiscount / 100);
    currentPrice -= pixDiscountValue;
  }

  return parseFloat(currentPrice);
}

export function calcPrice(wasPreviousStudent, offer, billingType) {
  const resellDiscountEnabled = offer?.hasStudentDiscount && wasPreviousStudent;
  const price = resellDiscountEnabled ? offer?.resellPrice : offer?.price;
  const pixDiscountPercentage = offer?.pixDiscount / 100;
  const pixDiscountValue = price * pixDiscountPercentage;
  const finalPrice =
    billingType == PIX_METHOD ? price - pixDiscountValue : price;

  return parseFloat(finalPrice);
}

export function calculateCouponDiscountValue(coupon, price) {
  if (!coupon) return 0;

  if (coupon.couponType == COUPON_TYPE_PERCENTAGE) {
    const percent = coupon.value / 100;
    return parseFloat(price) * percent;
  }

  return parseFloat(coupon.value);
}

export function couponDiscount(
  coupon,
  offer,
  currentPrice,
  compareDiscountValue
) {
  if (!coupon) return 0;

  const baseCouponDiscount = calculateCouponDiscountValue(coupon, offer?.price);
  if (coupon.nonCumulative) {
    return baseCouponDiscount >= compareDiscountValue ? baseCouponDiscount : 0;
  }

  return calculateCouponDiscountValue(coupon, currentPrice);
}

export function installmentInterestValue(
  wasPreviousStudent,
  offer,
  coupon,
  installmentCount,
  billingType
) {
  if (
    installmentCount &&
    offer?.interestStartsAt &&
    installmentCount >= offer?.interestStartsAt
  ) {
    const valueWithInterst = paymentValueWithInterest(
      wasPreviousStudent,
      offer,
      coupon,
      installmentCount,
      billingType
    );
    const value = calcValue(wasPreviousStudent, offer, coupon, billingType);

    return valueWithInterst - value;
  }

  return 0;
}

export function paymentValueWithInterest(
  wasPreviousStudent,
  offer,
  coupon,
  installmentCount,
  billingType
) {
  const i = parseFloat(offer.installmentInterest) / 100;
  const pv = calcValue(wasPreviousStudent, offer, coupon, billingType);
  const n = installmentCount;

  return pv * (((1 + i) ** n * i) / ((1 + i) ** n - 1)) * n; // Total PMT formula
}

export default function calcPaymentValue(
  wasPreviousStudent,
  offer,
  coupon,
  installmentCount,
  billingType
) {
  const value = calcValue(wasPreviousStudent, offer, coupon, billingType);
  const interest = installmentInterestValue(
    wasPreviousStudent,
    offer,
    coupon,
    installmentCount,
    billingType
  );

  return value + interest;
}
